import { useEffect } from "react";

// Adds the `visible` class to all `.fade-in` elements as they scroll into view.
// Re-runs whenever `deps` change (e.g., when language toggles and re-renders happen).
export default function useFadeIn(deps = []) {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    const els = document.querySelectorAll(".site-root .fade-in:not(.visible)");
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, deps);
}
